import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

// App Routes
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import {
  MatFormFieldModule,
  MatInputModule,
  MatIconModule,
  MatDividerModule,
} from "@angular/material";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { TokenInterceptor } from "./shared/interceptors/token-interceptor";
import { Ng4LoadingSpinnerModule } from "ng4-loading-spinner";

import { MsalModule, MsalInterceptor } from "@azure/msal-angular";
import { environment } from 'src/environments/environment';
import { HeaderInterceptor } from './shared/interceptors/header-interceptor';

export const protectedResourceMap: [string, string[]][] = [
  ['https://graph.microsoft.com/v1.0/me', ['user.read']]
];

const GRAPH_ENDPOINT = 'https://graph.microsoft.com/v1.0/me';

const isIE =
  window.navigator.userAgent.indexOf("MSIE ") > -1 ||
  window.navigator.userAgent.indexOf("Trident/") > -1;

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    Ng4LoadingSpinnerModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    HttpClientModule,
    MatDividerModule,
    MsalModule.forRoot({
      auth: {
        clientId: "bcce3128-ca7e-4ee9-b924-115c22a55a5f", // Application (client) ID from the app registration
        authority:
          "https://login.microsoftonline.com/d5cc1eb2-a038-4ef9-ab86-0d78702df2be", // The Azure cloud instance and the app's sign-in audience (tenant ID, common, organizations, or consumers)
        redirectUri: environment.redirectUrl, // This is your redirect URI
      },
      cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: isIE, // Set to true for Internet Explorer 11
      },
    }, {
      popUp: false,
      consentScopes: [
        'user.read',
        'openid',
        'profile',
      ],
      unprotectedResources: [],
      protectedResourceMap: [[GRAPH_ENDPOINT, ['user.read']]],
      extraQueryParameters: {}
    }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor, 
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderInterceptor,
      multi: true,
    },
  ],

  bootstrap: [AppComponent],
})
export class AppModule {}
